import { render } from "./instruksi-soal-benar-salah.vue?vue&type=template&id=ee89d196&scoped=true"
import script from "./instruksi-soal-benar-salah.vue?vue&type=script&lang=js"
export * from "./instruksi-soal-benar-salah.vue?vue&type=script&lang=js"

import "./instruksi-soal-benar-salah.vue?vue&type=style&index=0&id=ee89d196&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee89d196"]])

export default __exports__